import { createAction, props } from '@ngrx/store';
import { UpdateMembershipParam, GetAllMembershipParam, GetMembershipByResidentAndStatusesParam, CancelMembershipParam } from '@resident-select/domain/membership';
import { SciGuaduaTransaction } from '@scifamek/guadua';

export const UpdateMembershipCommand = createAction(
  'UpdateMembershipCommand',
  props<SciGuaduaTransaction<UpdateMembershipParam>>()
);

export const GetAllMembershipCommand = createAction(
  'GetAllMembershipCommand',
  props<SciGuaduaTransaction<GetAllMembershipParam>>()
);

export const GetMembershipByResidentAndStatusesCommand = createAction(
  'GetMembershipByResidentAndStatusesCommand',
  props<SciGuaduaTransaction<GetMembershipByResidentAndStatusesParam>>()
);

export const CancelMembershipCommand = createAction(
  'CancelMembershipCommand',
  props<SciGuaduaTransaction<CancelMembershipParam>>()
);
